import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { AdmissionGroupedProcedureRegion } from 'src/app/model/admission-grouped-procedure-region/admission-grouped-procedure-region';

@Injectable({
  providedIn: 'root'
})
export class AdmissionGroupedProcedureRegionService {

  constructor( private dataService: DataService ) { }

  private readonly groupEndPoint: string = '/admissionGroupedProcedureRegion/group/';

  async group(procedureRegionIds: number[], entityId: number): Promise<AdmissionGroupedProcedureRegion[]> {
    const params =  {
      procedureRegionIds,
      entityId
    };
    return await this.dataService.post<AdmissionGroupedProcedureRegion[]>(this.groupEndPoint, params).toPromise();
  }

}
